// extracted by mini-css-extract-plugin
export default {"toggleServicesSection":"verification-services-container__toggle-services-section__dmWR9"};